//Created by JC - 21 Dec 2024

window.addEventListener('load', function () {
  const preloader = document.getElementById('preloader');

  // Set a 2-second delay before starting to fade out
  setTimeout(function () {
    preloader.classList.add('fade-out');  // Trigger fade-out animation
  }, 1500);  // 2000ms = 2 seconds

  // Set another timeout to completely hide the preloader after fading
  setTimeout(function () {
    preloader.style.display = 'none';  // Hide the preloader after it fades
  }, 2500);  // 3000ms = 3 seconds (including the 1-second fade-out duration)
});

